var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 const { hoursObj } = options; 
__p+='\n\n<table id="officeHoursTable" class="office-hours-table">\n  <tbody>\n    ';
 Object.entries(hoursObj).forEach(([key, val]) => { 
__p+='\n    <tr>\n      <td>'+
((__t=( key ))==null?'':__t)+
'</td>\n      <td>'+
((__t=( val ))==null?'':__t)+
'</td>\n    </tr>\n    ';
 }) 
__p+='\n  </tbody>\n</table>\n';
return __p;
};



// WEBPACK FOOTER //
// ./shared_non_critical/parsers/officeHoursTable.jst.ejs